export default __webpack_public_path__ + "static/media/background-modal.c68abb40.svg";